module.exports = __webpack_public_path__ + "img/machine-bg.7e9c45ef.7e9c45ef.jpg";